/**
 * Wayfinding Component
 * @module patterns/components/navigation/wayfinding-bar/wayfinding-bar
 */
import { type App } from '~/app';

import JsController from '../../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'Wayfinding Bar');
    controller.addMountFunction(() => {
        mountWayfindingBar(controller);
    })

    return controller.init();
}

function mountWayfindingBar(controller: JsController) {
    const elements = document.querySelectorAll<HTMLElement>('.wayfinding-bar');
    let index = 0;
  
    for (const element of elements) {
        handleWayfindingBarBulletClick(controller, element);
        displayWayfindingBullets(element);
        handleWayfindingScroll(element)
        
        index = index + 1;
    }
}


const handleWayfindingBarBulletClick = (controller: JsController, element: HTMLElement) => {
    const wayfindingBullets = element.querySelectorAll<HTMLElement>('.wayfinding-bullet');
    
    for (const wayfindingBullet of wayfindingBullets) {
        controller.addListener(wayfindingBullet, "click", () => {
            const wayfindingId = wayfindingBullet.dataset.wayfindingId;
            const activeLink = document.querySelector(`[data-wayfinding-id="${wayfindingId}"]`);
            activeLink?.scrollIntoView({behavior: "smooth", inline: "center"});

            for (const bullet of wayfindingBullets) {
                bullet.classList.remove('first:active-bullet','active-bullet');
            }

            wayfindingBullet.classList.add('active-bullet');
        });
            
    }
}

const displayWayfindingBullets = (element: HTMLElement) => {
    const wayfindingBulletContainer = element.querySelector<HTMLElement>('.wayfinding-bullet-container') ;
    const wayfindingLinkContainer = element.querySelector<HTMLElement>('.wayfinding-link-container') ;
    if (!wayfindingBulletContainer || !wayfindingLinkContainer) return;

    const checkOverflowAndDisplayBullets = () => {
        const isOverflowing = wayfindingLinkContainer.scrollWidth > wayfindingLinkContainer.clientWidth;
        if (isOverflowing) {
            wayfindingBulletContainer.classList.remove('hidden');
        } else {
            wayfindingBulletContainer.classList.add('hidden');
        }
    };

    // Initial check
    checkOverflowAndDisplayBullets();

    // Check on screen resize
    window.addEventListener('resize', checkOverflowAndDisplayBullets);

};


function handleWayfindingScroll( element : HTMLElement){
    const wayfindingLinkContainer = element.querySelector<HTMLElement>('.wayfinding-link-container') ;

    wayfindingLinkContainer?.addEventListener('scroll', () => {
        const wayfindingLinkContainer = document.querySelector<HTMLElement>('.wayfinding-link-container')!;
        const scrollPercentage = checkWayfindingScrollPercent(wayfindingLinkContainer);

        //Shows active pip when dragging wayfinding links on mobile
        wayfindingLinkContainer.addEventListener('touchmove', handleTouchMove);

        function handleTouchMove(){
            const wayfindingLinkBullets = document.querySelectorAll<HTMLElement>('.wayfinding-bullet')!;
            for (const [index, bullet] of [...wayfindingLinkBullets].entries()) {
                const bulletPercentageLower = Math.ceil(100 / wayfindingLinkBullets.length) * index
                const bulletPercentageHigher = Math.ceil(100 / wayfindingLinkBullets.length) * (index + 1)
                bullet.classList.remove('first:active-bullet');
                if (bulletPercentageLower <= scrollPercentage && scrollPercentage <= bulletPercentageHigher) {
                    bullet.classList.add('active-bullet');
                }else{
                    bullet.classList.remove('active-bullet');
                } 
            }
        }
    } );
}

function checkWayfindingScrollPercent(element: HTMLElement) {
    const scrollableWidth = element.scrollWidth - element.clientWidth;
    const currentScroll = element.scrollLeft;
    const scrollPercentage = Math.floor((currentScroll / scrollableWidth) * 100);

    return scrollPercentage;
}
